module.exports = __webpack_public_path__ + "static/media/masthead-countryman.7e5ebea6.svg";